export default __webpack_public_path__ + "static/media/Emerald_product.85d19977.png";